module.exports = __webpack_public_path__ + "static/media/instagram-icon.42de59fa.svg";